import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';

export const ArchiveAllTicketValidationSchema = z.object({
  spaceColumnId: z.string({ message: 'Space Column ID is required' }).min(1),
});
export type TArchiveAllTicketValidation = z.infer<typeof ArchiveAllTicketValidationSchema>;
export type TArchiveAllTicketPayload = TArchiveAllTicketValidation;
export type TArchiveAllTicketResponse = ApiResponse<{
  message: string;
}>;

export const archiveAllTicket = async (payload: TArchiveAllTicketPayload): Promise<TArchiveAllTicketResponse> => {
  const url = `/ticket/archive-column/${payload.spaceColumnId}`;

  return axiosInstance.patch(url);
};

/**
 * Use Archive All Ticket React-Query Hook
 */
type UseArchiveAllTicketMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof archiveAllTicket, AxiosErrorCustom>;
};

/**
 * Use Archive All Ticket React-Query Hook
 */
export const useArchiveAllTicketMutation = ({ mutationConfig }: UseArchiveAllTicketMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: archiveAllTicket,
    ...restConfig,
  });
};
